export default __webpack_public_path__ + "static/elpi-ea8a83333de1156f6dacf39ce78780b9.png";